// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import { deepCopy } from "@/utils/validate";
import SupConstructionChooseDialog from "../../components/supConstructionChooseDialog/index.vue";
import CorpBasicinfoChoose from "../../components/corpBasicinfoChoose/index.vue";
import RegPersonBasicinfoChoose from "../../components/regPersonBasicinfoChoose/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import RecordDirectlyLogs from "../recordDirectlyLogs/index.vue";
import OrganizationAllocation from "../organizationAllocation/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "发包人及项目信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.projectInformation()
        },
        {
          name: "施工单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.constructionUnitrmation()
        },
        {
          name: "监理单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.superUnitrmation()
        },
        {
          name: "其他单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.constructionOtherUnitmation()
        },
        {
          name: "其他信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.otherInformation()
        }
      ],
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        id: null, // 主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        lockNo: null, // CA锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null, // 时间戳
        inputPerson: null, // 录入人员
        inputMode: null, // 录入方式
        insertDate: null, // 插入日期
        updateDate: null, // 更新日期
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        contractorLockNo: null, // 施工方CA锁编号
        contractorDigitalSignature: null, // 施工方数字签名
        contractorTimeStamp: null, // 施工方时间戳
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        projectManagerId: null, // 项目经理解锁变更记录表主键
        updateFlag: null, // 修改标志（修改发包人或施工方）
        recordState: null, // 备案状态(0正常，1解除合同，2申请解除中)
        isAuditOk: null, // 审核通过的标志
        actualAuditTime: null, // 实际审核推送时间
        auditFinalTime: null, // 审核最终时间
        projectLeaderNumber: null, // 审核最终时间
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        publishState: null, // 公示状态
        expectAuditTime: null, // 预计审核推送时间
        totalInvestment: null, // 批准投资总额（万元）
        projectManagerIdCard: null, // 项目经理身份证号码
        projectLeaderName: null, // 公示项目负责人名称
        isUnion: null, // 是否允许联合体
        econUnit: null, // 勘察单位
        econUnitName: null, // 勘察单位名称
        econProjectManager: null, // 勘察项目负责人
        econProjectManagerName: null, // 勘察项目经理名称
        econProjectManagerIdCard: null, // 勘察项目经理身份证号码
        designUnit: null, // 设计单位
        designUnitName: null, // 设计单位名称
        designProjectManager: null, // 设计项目负责人
        designProjectManagerName: null, // 设计项目经理名称
        designProjectManagerIdCard: null, // 设计项目经理身份证号码
        superUnit: null, // 监理单位
        superUnitName: null, // 监理单位名称
        superProjectManager: null, // 监理项目负责人
        superProjectManagerName: null, // 监理项目经理名称
        superProjectManagerIdCard: null, // 监理项目经理身份证号码
        superQualificationCategories: null, // 监理企业资质类别及等级
        superQualificationCategoryLevel: null, // 监理执业资格类别等级及编号
        superManagerCertificateNumber: null, // 监理项目经理安全生产考核合格证书编号
        superManagementCertificateNumber: null, // 监理专职安全生产管理人员安全生产考核合格证书编号
        superManagementCertificateName: null, // 监理专职安全生产管理人员姓名
        superPlanTimeLimit: null, // 监理计划工期
        superProjectCost: null, // 监理工程造价
        constructionState: null, // 施工单位确认状态
        constructionSealDate: null, // 施工单位盖章日期
        econState: null, // 勘察单位确认状态
        econSealDate: null, // 勘察单位盖章日期
        designState: null, // 设计单位确认状态
        designSealDate: null, // 设计单位盖章日期
        superState: null, // 监理单位确认状态
        superSealDate: null, // 监理单位盖章日期
        econProjectCost: null, // 勘察工程造价
        designProjectCost: null // 设计工程造价
      },
      // 表单错误提示
      errRules: {
        id: null, // 主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        lockNo: null, // CA锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null, // 时间戳
        inputPerson: null, // 录入人员
        inputMode: null, // 录入方式
        insertDate: null, // 插入日期
        updateDate: null, // 更新日期
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        contractorLockNo: null, // 施工方CA锁编号
        contractorDigitalSignature: null, // 施工方数字签名
        contractorTimeStamp: null, // 施工方时间戳
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        projectManagerId: null, // 项目经理解锁变更记录表主键
        updateFlag: null, // 修改标志（修改发包人或施工方）
        recordState: null, // 备案状态(0正常，1解除合同，2申请解除中)
        isAuditOk: null, // 审核通过的标志
        actualAuditTime: null, // 实际审核推送时间
        auditFinalTime: null, // 审核最终时间
        projectLeaderNumber: null, // 审核最终时间
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        publishState: null, // 公示状态
        expectAuditTime: null, // 预计审核推送时间
        isUnion: null, // 是否允许联合体
        econUnit: null, // 勘察单位
        econUnitName: null, // 勘察单位名称
        econProjectManager: null, // 勘察项目负责人
        econProjectManagerName: null, // 勘察项目经理名称
        designUnit: null, // 设计单位
        designUnitName: null, // 设计单位名称
        designProjectManager: null, // 设计项目负责人
        designProjectManagerName: null, // 设计项目经理名称
        superUnit: null, // 监理单位
        superUnitName: null, // 监理单位名称
        superProjectManager: null, // 监理项目负责人
        superProjectManagerName: null, // 监理项目经理名称
        superQualificationCategories: null, // 监理企业资质类别及等级
        superQualificationCategoryLevel: null, // 监理执业资格类别等级及编号
        superManagerCertificateNumber: null, // 监理项目经理安全生产考核合格证书编号
        superManagementCertificateNumber: null, // 监理专职安全生产管理人员安全生产考核合格证书编号
        superManagementCertificateName: null, // 监理专职安全生产管理人员姓名
        superPlanTimeLimit: null, // 监理计划工期
        constructionState: null, // 施工单位确认状态
        constructionSealDate: null, // 施工单位盖章日期
        econState: null, // 勘察单位确认状态
        econSealDate: null, // 勘察单位盖章日期
        designState: null, // 设计单位确认状态
        designSealDate: null, // 设计单位盖章日期
        superState: null, // 监理单位确认状态
        superSealDate: null, // 监理单位盖章日期
        econProjectCost: null, // 勘察工程造价
        designProjectCost: null, // 设计工程造价
        superProjectCost: null // 监理工程造价
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg,
      // 显示标志
      showFlag: false,
      // 项目负责人选择显示标志
      managerShowFlag: false,
      // 联合体选择显示标志
      unionShowFlag: false,
      // 房屋建筑工程建筑面积置灰
      constructionAreaDisabled: false,
      // 计划工期置灰
      planTimeLimitDisabled: false,
      // 工程造价
      projectCostDisabled: false,
      // 勘察工程造价
      econProjectCostDisabled: true,
      // 设计工程造价
      designProjectCostDisabled: true,
      // 监理工程造价
      superProjectCostDisabled: false,
      // 用于判断状态图片
      flagState: null,
      /***************************************联合体单位*******************************************/
      unionLoading: false, // 列表loading状态
      // 联合体单位表单
      unionForm: {
        unionCorpId: null, // 联合体单位编号
        unionCorpName: null, // 联合体单位名称
        unionUnitType: null, // 联合体单位类型
        unionUnitTypeName: null // 联合体单位类型名称
      },
      // 表格基础数据
      unionTableColumns: [
        {
          label: "联合体单位名称",
          prop: "unionCorpName"
        },
        {
          label: "联合体单位类型",
          prop: "unionUnitTypeName"
        },
        {
          label: "是否同意",
          slotName: "isAgree"
        },
        {
          label: "确认日期",
          prop: "sealDate"
        },
        {
          label: "操作",
          slotName: "operation"
        }
      ],
      // 表格数据
      unionTableData: [],
      unionFlag: null // 联合体标志
    };
  },

  // 注册组件
  components: {
    SupConstructionChooseDialog, // 项目登记选择
    CorpBasicinfoChoose, // 施工方选择
    RegPersonBasicinfoChoose, // 项目负责人选择
    RecordDirectlyLogs, // 直接发包备案日志
    OrganizationAllocation, // 施工单位项目管理机构配备情况表
    AuditHistoryRecord, // 历史核验记录
    TenderPictureinfor // 附件页面
  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 获取详情
    this.fun_GetDetail();
    // 获取联合体数据
    this.fun_ContractRecordUnionList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_PostAction("/contractRecordDirectly/detail", {
        id: this.id,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 下拉框值改变事件
          this.fun_GetSelectVal(this.form.tenderContentNum, "tenderContentNum");
          // 获取状态用于判断显示图片
          this.flagState = data.state;
          // 房屋建筑工程建筑面积不为空
          if (data.constructionArea) {
            // 设置
            this.form.constructionArea = data.constructionArea.toString();
          }
          // 工程造价不为空
          if (data.projectCost) {
            // 设置
            this.form.projectCost = data.projectCost.toString();
          }
          // 勘察工程造价不为空
          if (data.econProjectCost) {
            // 设置
            this.form.econProjectCost = data.econProjectCost.toString();
          }
          // 设计工程造价不为空
          if (data.designProjectCost) {
            // 设置
            this.form.designProjectCost = data.designProjectCost.toString();
          }
          // 监理工程造价不为空
          if (data.superProjectCost) {
            // 设置
            this.form.superProjectCost = data.superProjectCost.toString();
          }
          // 执行处理页面显示方法
          this.fun_GetHandle();
          // 设置备案项目内容下拉框
          this.fun_SelectTenderContentNum();
          // 解除合同时
          if (this.controllerFlg === "jcht") {
            this.stepsList.forEach(item => {
              if (item.name === "其他单位信息") {
                item.formList.forEach(e => {
                  e.formConfigList.forEach(f => {
                    // 是否联合体取消非空验证
                    if (f.value === "isUnion") {
                      f.required = false;
                      f.rule = {
                        required: false,
                        message: "该输入项不能为空",
                        trigger: "change"
                      };
                    }
                  });
                });
              }
            });
          }
          if (this.controllerFlg === "update") {
            if (
              this.form.econUnitName != null &&
              this.form.econUnitName != ""
            ) {
              // 勘察工程造价
              this.econProjectCostDisabled = false;
            }
            if (
              this.form.designUnitName != null &&
              this.form.designUnitName != ""
            ) {
              // 设计工程造价
              this.designProjectCostDisabled = false;
            }
            if (
              this.form.superUnitName != null &&
              this.form.superUnitName != ""
            ) {
              // 监理工程造价
              this.superProjectCostDisabled = false;
            }
          }
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 联合体单位集合
     */
    fun_ContractRecordUnionList() {
      // 主键不为空
      if (this.id) {
        // 打开loading
        this.unionLoading = true;
        // 发起请求
        fun_PostAction("/contractRecordDirectly/unionList", {
          recordDirectlyId: this.id
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 联合体列表数据
            this.unionTableData = data;
          }
          // 关闭加载
          this.unionLoading = false;
        });
      }
    },
    /**
     * 页面显示
     */
    fun_GetHandle() {
      // 备案状态是1解除合同或者2申请解除中,
      if (this.form.recordState == "1" || this.form.recordState == "2") {
        // 是否存在
        let rtn = false;
        // 遍历查询表单
        this.stepsList[0].formList.map(item => {
          // 如果是解除合同文件扫描件
          if (item.title === "解除合同文件扫描件") {
            // 设置为存在
            rtn = true;
          }
        });
        // 如果不存在
        if (!rtn) {
          // 删除
          this.stepsList[0].formList.splice(1, 0, {
            title: "解除合同文件扫描件",
            name: "2",
            icon: "",
            formConfigList: [
              {
                label: "解除合同文件扫描件：",
                value: "uploadFile",
                type: "slot",
                slotName: "uploadFile",
                width: "100%"
              }
            ]
          });
        }
      }
      // 备案状态是1解除合同或者2申请解除中,
      if (this.form.state == "tj" && this.form.expectAuditTime) {
        // 是否存在
        let rtn = false;
        // 遍历查询表单
        this.stepsList[0].formList.map(item => {
          // 如果是预计审核推送时间
          if (item.title === "预计审核推送时间") {
            // 设置为存在
            rtn = true;
          }
        });
        // 如果不存在
        if (!rtn) {
          // 添加
          this.stepsList[0].formList.splice(2, 0, {
            title: "预计审核推送时间",
            name: "3",
            icon: "",
            formConfigList: [
              {
                label: "预计审核推送时间：",
                value: "expectAuditTime",
                type: "input",
                disabled: true
              }
            ]
          });
        }
      }
      // 如果是新增或者修改并且公示标志不是提交
      if (
        (this.controllerFlg == "update" || this.controllerFlg == "insert") &&
        this.form.publishState != "tj"
      ) {
        // 显示标志
        this.showFlag = true;
        // 项目负责人选择显示标志
        this.managerShowFlag = true;
        // 联合体单位选择显示标志
        this.unionShowFlag = true;
      }
      // 如果操作类型时详情或者解除合同或者修改标志为0或1
      if (
        this.controllerFlg == "detail" ||
        this.controllerFlg == "jcht" ||
        this.form.updateFlag == "0" ||
        this.form.updateFlag == "1"
      ) {
        // 房屋建筑工程建筑面积置灰
        this.constructionAreaDisabled = true;
        // 计划工期置灰
        this.planTimeLimitDisabled = true;
        // 工程造价置灰
        this.projectCostDisabled = true;
        // 监理工程造价置灰
        this.superProjectCostDisabled = true;
        // 遍历流程
        this.stepsList.map(e => {
          (e.isSave = true), // 默认保存
            (e.isActive = true); // 默认可点击
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 置灰
              form.disabled = true;
            });
          });
        });
        // 如果修改标志不为空并且备案状态等于0，并且操作标志不是详情
        if (
          this.form.updateFlag &&
          this.form.recordState == "0" &&
          this.controllerFlg != "detail"
        ) {
          // 计划工期取消置灰
          this.planTimeLimitDisabled = false;
          // 工程造价取消置灰
          this.projectCostDisabled = false;
          // 显示标志不显示
          this.showFlag = false;
          // 遍历流程
          this.stepsList.map(e => {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历标签页内表单
              formList.formConfigList.map(form => {
                // 如果是
                if (
                  form.value == "qualificationCategories" || // 企业资质类别及等级
                  form.value == "qualificationCategoryLevel" || // 执业资格类别等级及编号
                  form.value == "managerCertificateNumber" || // 项目负责人安全生产考核合格证书编号
                  form.value == "managementCertificateName" || // 专职安全生产管理人员姓名
                  form.value == "managementCertificateNumber" || // 专职安全生产管理人员安全生产考核合格证书编号
                  form.value == "contractScope" || // 发包范围
                  form.value == "remarks" // 备注
                ) {
                  // 取消置灰
                  form.disabled = false;
                }
              });
            });
          });
        }
      }
      // 如果不是联合体
      if (this.form.isUnion == "0" || !this.form.isUnion) {
        // 如果不能显示
        if (!this.unionShowFlag) {
          // 重新设置联合体单位信息
          this.stepsList[3].formList[1].formConfigList = [
            {
              label: "是否联合体：",
              value: "isUnion",
              type: "select",
              clearable: true,
              disabled: true,
              optionData: [
                { name: "是", value: "1" },
                { name: "否", value: "0" }
              ],
              rule: {
                required: true,
                message: "该输入项不能为空",
                trigger: "change"
              }
            }
          ];
        } else {
          // 重新设置联合体单位信息
          this.stepsList[3].formList[1].formConfigList = [
            {
              label: "是否联合体：",
              value: "isUnion",
              type: "select",
              clearable: true,
              disabled: false,
              optionData: [
                { name: "是", value: "1" },
                { name: "否", value: "0" }
              ],
              rule: {
                required: true,
                message: "该输入项不能为空",
                trigger: "change"
              }
            }
          ];
        }
        // 遍历
        this.stepsList[3].formList.map((item, num) => {
          // 匹配联合体协议扫描件
          if (item.title === "联合体协议扫描件") {
            // 删除
            this.stepsList[3].formList.splice(num, 1);
          }
        });
      }
      // 如果是联合体
      else {
        // 如果不能显示
        if (!this.unionShowFlag) {
          // 重新设置联合体单位信息
          this.stepsList[3].formList[1].formConfigList = [
            {
              label: "是否联合体：",
              value: "isUnion",
              type: "select",
              clearable: true,
              disabled: true,
              optionData: [
                { name: "是", value: "1" },
                { name: "否", value: "0" }
              ],
              rule: {
                required: true,
                message: "该输入项不能为空",
                trigger: "change"
              }
            },
            {
              type: "slot",
              class: "formList",
              slotName: "unionList"
            }
          ];
        }
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
      // 备案项目类别
      if (i === "tenderClassNum") {
        // 设置备案项目内容下拉框
        this.fun_SelectTenderContentNum();
      }
      // 备案项目内容
      if (i === "tenderContentNum") {
        // 监理
        if (e === "201603181128490021") {
          // 遍历流程
          this.stepsList.map(item => {
            if (item.name === "监理单位信息") {
              item.formList.forEach(es => {
                es.formConfigList.forEach(ee => {
                  this.$set(ee, "required", true);
                  if (ee.rule) ee.rule.required = true;
                });
              });
            }
            if (item.name === "施工单位信息") {
              item.formList.forEach(es => {
                es.formConfigList.forEach(ee => {
                  this.$set(ee, "required", false);
                  if (ee.rule) ee.rule.required = false;
                });
              });
            }
          });
        } else {
          // 施工单位必填
          // 遍历流程
          this.stepsList.map(item => {
            if (item.name === "施工单位信息") {
              item.formList.forEach(es => {
                es.formConfigList.forEach(ee => {
                  this.$set(ee, "required", true);
                  if (ee.rule) ee.rule.required = true;
                });
              });
            } else if (item.name === "监理单位信息") {
              item.formList.forEach(es => {
                es.formConfigList.forEach(ee => {
                  this.$set(ee, "required", false);
                  if (ee.rule) ee.rule.required = false;
                });
              });
            }
          });
        }
      }
      // 是否联合体
      else if (i === "isUnion") {
        // 设置是否联合体样式
        this.fun_IsUnionStyle();
      }
    },
    /**
     * 设置备案项目内容下拉框
     */
    fun_SelectTenderContentNum() {
      // 备案项目类别不为空
      if (this.form.tenderClassNum) {
        // 遍历流程
        this.stepsList.map(item => {
          // 遍历流程表单
          item.formList.map(formList => {
            // 遍历表单内容
            formList.formConfigList.map(formConfigList => {
              // 如果是备案项目内容
              if (formConfigList.value === "tenderContentNum") {
                // 修改下拉框请求参数，重新赋值
                formConfigList.queryParams = {
                  url: "/dataDictionaryEntries/recordCombobox",
                  tenderClassNum: this.form.tenderClassNum
                };
              }
            });
          });
        });
      }
    },
    /**
     * 是否联合体样式
     */
    fun_IsUnionStyle() {
      // 如果是联合体
      if (this.form.isUnion == "1") {
        // 是否存在
        let rtn = false;
        // 遍历查询表单
        this.stepsList[3].formList[1].formConfigList.map((item, num) => {
          // 如果是联合体单位
          if (item.value === "unionCorpName") {
            // 设置为存在
            rtn = true;
          }
        });
        // 如果不存在
        if (!rtn) {
          // 重新设置联合体单位信息
          this.stepsList[3].formList[1].formConfigList = [
            {
              label: "是否联合体：",
              value: "isUnion",
              type: "select",
              clearable: true,
              disabled: false,
              optionData: [
                { name: "是", value: "1" },
                { name: "否", value: "0" }
              ]
            },
            {
              label: "联合体单位：",
              type: "slot",
              slotName: "unionCorpName",
              value: "unionCorpName",
              width: "100%;"
            },
            {
              label: "联合体单位类型：",
              type: "slot",
              slotName: "unionUnitType",
              value: "unionUnitType",
              width: "50%;"
            },
            {
              type: "slot",
              class: "formList",
              slotName: "unionList"
            }
          ];
        }
      }
      // 如果不是联合体
      else {
        // 重新设置联合体单位信息
        this.stepsList[3].formList[1].formConfigList = [
          {
            label: "是否联合体：",
            value: "isUnion",
            type: "select",
            clearable: true,
            disabled: false,
            optionData: [
              { name: "是", value: "1" },
              { name: "否", value: "0" }
            ]
          }
        ];
      }
    },
    /**
     * 设置联合体单位类型下拉框
     */
    fun_SelectUnionUnitType(e) {
      // 赋值联合体单位类型
      this.unionForm.unionUnitType = e.code;
      // 遍历其中的options数据
      e.options.find(data => {
        // 如果是选中的编号
        if (data.value == e.code) {
          // 赋值联合体单位类型
          this.unionForm.unionUnitTypeName = data.name;
        }
      });
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否可点击
      if (val.isActive) {
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果不是详情
        if (
          (this.controllerFlg == "update" || this.controllerFlg == "insert") &&
          this.form.publishState != "tj" &&
          (!this.form.state || this.form.state == "bc")
        ) {
          // 判断是否填写项目名称
          if (!this.form.prjName) {
            // 提示
            this.$alert("请填写工程名称！", "warning");
            this.errRules.prjName = "请填写工程名称！";
            return false;
          }
          // 保存当前表单
          this.fun_SaveOrUpdate("bc");
        }
        // 赋值下标
        this.stepsActive = index;
        // 获取表单数据
        this.formConfigList = val.formList;
        // 设置备案项目内容下拉框
        this.fun_SelectTenderContentNum();
      }
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 如果不是详情
      if (
        (this.controllerFlg == "update" || this.controllerFlg == "insert") &&
        this.form.publishState != "tj" &&
        (!this.form.state || this.form.state == "bc")
      ) {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写工程名称！", "warning");
          this.errRules.prjName = "请填写工程名称！";
          return false;
        }
        // 保存当前表单
        this.fun_SaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 如果不是详情
      if (
        (this.controllerFlg == "update" || this.controllerFlg == "insert") &&
        this.form.publishState != "tj" &&
        (!this.form.state || this.form.state == "bc")
      ) {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写工程名称！", "warning");
          this.errRules.prjName = "请填写工程名称！";
          return false;
        }
        // 保存当前表单
        this.fun_SaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 加1
      this.stepsActive++;
      // 设置下一个流程可点击
      this.stepsList[this.stepsActive].isActive = true;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      let formArr = []; // 所有表单
      let isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断当前表单
      for (var i = 0; i < formArr.length; i++) {
        // 判断字段是否填写值
        if (this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit(state) {
      // 如果是保存
      if (state === "bc") {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写工程名称！", "warning");
          this.errRules.prjName = "请填写工程名称！";
          return false;
        }
        // 保存
        this.fun_SaveOrUpdate(state);
        return;
      }
      // 自定义下标
      let i = 0;
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 重置表单配置
          this.formConfigList = this.stepsList[i].formList;
          this.$nextTick(() => {
            // 验证表单
            this.fun_val(i, state);
          });
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_val(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 如果是提交
            if (state == "tj") {
              this.fun_VisibleChange(state);
            } else {
              // 执行保存
              this.fun_SaveOrUpdate(state);
            }
          } else {
            // 重置表单配置
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(() => {
              // 递归验证表单
              this.fun_val(i + 1, state);
            });
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 提交时验证
     */
    fun_VisibleChange(state) {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 如果勘察单位不为空
      if (this.form.econUnit) {
        // 勘察项目负责人为空
        if (!this.form.econProjectManager) {
          // 默认获取第一个流程表单
          this.formConfigList = this.stepsList[3].formList;
          // 错误提示
          this.errRules.econProjectManagerName =
            "已选择勘察单位，请选择勘察单位项目负责人！";
          this.$message.error("已选择勘察单位，请选择勘察单位项目负责人！");
          return false;
        }
        // 勘察工程造价为空
        if (
          !this.form.econProjectCost ||
          this.form.econProjectCost == 0 ||
          this.form.econProjectCost == 0.0
        ) {
          // 默认获取第一个流程表单
          this.formConfigList = this.stepsList[3].formList;
          // 错误提示
          this.errRules.econProjectCost =
            "已选择勘察单位，请填写勘察工程造价！";
          this.$message.error("已选择勘察单位，请填写勘察工程造价！");
          return false;
        }
      }
      // 如果设计单位不为空
      if (this.form.designUnit) {
        // 设计项目负责人为空
        if (!this.form.designProjectManager) {
          // 默认获取第一个流程表单
          this.formConfigList = this.stepsList[3].formList;
          // 错误提示
          this.errRules.designProjectManagerName =
            "已选择设计单位，请选择设计单位项目负责人！";
          this.$message.error("已选择设计单位，请选择设计单位项目负责人！");
          return false;
        }
        // 设计工程造价为空
        if (
          !this.form.designProjectCost ||
          this.form.designProjectCost == 0 ||
          this.form.designProjectCost == 0.0
        ) {
          // 默认获取第一个流程表单
          this.formConfigList = this.stepsList[3].formList;
          // 错误提示
          this.errRules.designProjectCost =
            "已选择设计单位，请填写设计工程造价！";
          this.$message.error("已选择设计单位，请填写设计工程造价！");
          return false;
        }
      }
      // // 如果监理单位不为空，监理项目负责人为空
      // if (this.form.superUnit) {
      //   // 设计项目负责人为空
      //   if (!this.form.superProjectManager) {
      //     // 默认获取第一个流程表单
      //     this.formConfigList = this.stepsList[2].formList;
      //     // 错误提示
      //     this.errRules.superProjectManagerName =
      //       "已选择监理单位，请选择监理单位项目负责人！";
      //     this.$message.error("已选择监理单位，请选择监理单位项目负责人！");
      //     return false;
      //   }
      //   // 监理工程造价为空
      //   if (
      //     !this.form.superProjectCost ||
      //     this.form.superProjectCost == 0 ||
      //     this.form.superProjectCost == 0.0
      //   ) {
      //     // 默认获取第一个流程表单
      //     this.formConfigList = this.stepsList[2].formList;
      //     // 错误提示
      //     this.errRules.superProjectCost =
      //       "已选择监理单位，请填写监理工程造价！";
      //     this.$message.error("已选择监理单位，请填写监理工程造价！");
      //     return false;
      //   }
      // }
      // 如果是联合体
      if (this.form.isUnion == "1") {
        // 如果未录入联合体信息
        if (this.unionTableData.length == 0) {
          // 默认获取第一个流程表单
          this.formConfigList = this.stepsList[3].formList;
          // 错误提示
          this.errRules.isUnion = "选择联合体时，请录入联合体信息！";
          // 错误提示
          this.$message.error("选择联合体时，请录入联合体信息！");
          return false;
        }
      }
      // 批准投资总额是否大于工程造价
      let flag = true;
      // 批准投资总额不为空并且不等于0
      if (
        this.form.totalInvestment &&
        this.form.totalInvestment != 0 &&
        this.form.totalInvestment != "0"
      ) {
        // 如果工程造价大于投资总额
        if (this.form.totalInvestment < this.form.projectCost) {
          // 设置标志
          flag = false;
        }
      }
      // 批准投资总额是否大于工程造价
      if (flag) {
        // 如果工程造价不为空
        if (this.form.projectCost) {
          // 提示消息
          let msg =
            '该项目填写的工程造价为<span style="color:red">' +
            this.form.projectCost +
            "（万元）</span>确定保存数据吗？";
          // 如果时解除合同
          if (this.controllerFlg == "jcht") {
            msg =
              '该项目<span style="color:red">申请解除合同</span>确定提交数据吗？';
          }
          // 弹出询问confirm
          this.$confirm(msg, "提示", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 执行保存
            this.fun_Confirm(state);
          });
        } else {
          // 执行保存
          this.fun_Confirm(state);
        }
      }
      // 批准投资总额是否小于工程造价
      else {
        // 如果工程造假不为空
        if (this.form.projectCost) {
          // 提示消息
          let msg =
            '该项目填写的工程造价为<span style="color:red">' +
            this.form.projectCost +
            '（万元）</span>大于批准投资总额<span style="color:red">' +
            this.form.totalInvestment +
            "（万元）</span>，确定保存数据吗？";
          // 如果时解除合同
          if (this.controllerFlg == "jcht") {
            msg =
              '该项目<span style="color:red">申请解除合同</span>确定提交数据吗？';
          }
          // 弹出询问confirm
          this.$confirm(msg, "提示", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 执行保存
            this.fun_Confirm(state);
          });
        } else {
          // 执行保存
          this.fun_Confirm(state);
        }
      }
    },
    /**
     * 提示
     */
    fun_Confirm(state) {
      // 审核状态
      if (this.form.publishState == "tj") {
        // 弹出询问confirm
        this.$confirm(
          "是否确定撤销【" + this.form.prjName + "】的项目公示？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          // 执行撤销
          this.fun_Cancellation();
        });
      } else {
        // 提示消息
        let msg =
          "确定进行提交操作吗？提交后将由施工单位确认后直接进行网上公示！";
        // 如果只修改了施工方信息时
        if (this.form.updateFlag == "0") {
          msg =
            "确定进行提交操作吗？提交后将由施工单位确认后直接提交监管部门审核！";
        }
        // 弹出询问confirm
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 执行保存
          this.fun_SaveOrUpdate(state);
        });
      }
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state) {
      // 状态赋值
      this.form.state = state;
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("contractRecordDirectly/saveOrUpdate", {
        ...this.form,
        controllerFlg: this.controllerFlg,
        unionList: JSON.stringify(this.unionTableData) // 联合体投标单位信息
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 如果返回成功
          if (data.result) {
            // 回传id
            this.id = data.model.id;
            // 加载框取消
            this.fullLoading.close();
            // 如果是保存
            if (this.form.state == "bc") {
              // 修改状态
              this.controllerFlg = "update";
              // 加载详情
              this.fun_GetDetail();
            } else {
              // 操作成功
              this.$message.success(data.rtnMsg);
              // 返回一览
              this.fun_Back();
            }
          }
          // 如果操作失败
          else {
            // 加载框取消
            this.fullLoading.close();
            // 提示请求失败消息
            this.$message.error(data.rtnMsg);
            // 如果是联合体附件上传错误
            if (data.data == "uploadFile") {
              // 默认获取第一个流程表单
              this.formConfigList = this.stepsList[3].formList;
            }
          }
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 如果页面验证失败
          if (data != null && data != "") {
            // 定义rules为一个随机数
            this.errRules = Math.random();
            // 执行延迟方法
            this.$nextTick(() => {
              // 提示
              this.$message.error("请按提示修改");
              // 默认获取第一个流程表单
              this.formConfigList = this.stepsList[1].formList;
              // 赋值错误消息
              this.errRules = data;
            });
          } else {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 撤回公示
     */
    fun_Cancellation() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("contractRecordDirectly/cancellation", {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.fun_Back();
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 打开项目登记选择弹窗
     * @author shuhua
     */
    fun_OpenProjectDialog() {
      // 打开弹窗
      this.$refs.supConstructionChooseDialog.dialogVisible = true;
      // 请求接口
      this.$refs.supConstructionChooseDialog.fun_GetList();
    },
    /**
     * 清空项目登记信息
     */
    fun_CleanProject() {
      // 清空项目编号
      this.form.constructionNo = null;
      // 清空项目名称
      this.form.prjName = null;
      // 清空批准投资总额
      this.form.totalInvestment = null;
    },
    /**
     * 设置项目登记信息
     */
    fun_SetProject(data) {
      // 设置项目编号
      this.form.constructionNo = data.constructionNo;
      // 设置项目名称
      this.form.prjName = data.prjName;
      // 设置批准投资总额
      this.form.totalInvestment = data.totalInvestment;
    },
    /**
     * 打开单位选择弹窗
     * @author shuhua
     */
    fun_OpenCorpBasicInfoDialog(e) {
      // 打开弹窗
      this.$refs.corpBasicinfoChoose.dialogVisible = true;
      // 设置单位类型
      this.$refs.corpBasicinfoChoose.unitType = e;
      // 设置联合体标志
      this.$refs.corpBasicinfoChoose.unionFlag = "0";
      // 请求接口
      this.$refs.corpBasicinfoChoose.fun_GetOpen();
    },
    /**
     * 清空施工单位
     */
    fun_CleanCorpBasicInfo(e) {
      // 施工单位
      if (e == "construction") {
        // 清空施工单位编号
        this.form.constructionUnit = null;
        // 清空施工单位名称
        this.form.constructionUnitName = null;
        // 清空项目负责人编号
        this.form.projectManager = null;
        // 清空项目负责人名称
        this.form.projectManagerName = null;
        // 清空项目负责人社会信用代码
        this.form.projectManagerIdCard = null;
      }
      // 勘察单位
      else if (e == "econ") {
        // 清空勘察单位编号
        this.form.econUnit = null;
        // 清空勘察单位名称
        this.form.econUnitName = null;
        // 清空勘察单位项目负责人编号
        this.form.econProjectManager = null;
        // 清空勘察单位项目负责人名称
        this.form.econProjectManagerName = null;
        // 清空勘察单位项目负责人社会信用代码
        this.form.econProjectManagerIdCard = null;
        this.econProjectCostDisabled = true;
        this.form.econProjectCost = 0;
      }
      // 设计单位
      else if (e == "design") {
        // 清空设计单位编号
        this.form.designUnit = null;
        // 清空设计单位名称
        this.form.designUnitName = null;
        // 清空设计单位项目负责人编号
        this.form.designProjectManager = null;
        // 清空设计单位项目负责人名称
        this.form.designProjectManagerName = null;
        // 清空设计单位项目负责人社会信用代码
        this.form.designProjectManagerIdCard = null;
        this.designProjectCostDisabled = true;
        this.form.designProjectCost = 0;
      }
      // 监理单位
      else if (e == "super") {
        // 清空监理单位编号
        this.form.superUnit = null;
        // 清空监理单位名称
        this.form.superUnitName = null;
        // 清空监理单位项目负责人编号
        this.form.superProjectManager = null;
        // 清空监理单位项目负责人名称
        this.form.superProjectManagerName = null;
        // 清空监理单位项目负责人社会信用代码
        this.form.superProjectManagerIdCard = null;
        this.superProjectCostDisabled = true;
        this.form.superProjectCost = 0;
      }
    },
    /**
     * 设置施工单位
     */
    fun_SetCorpBasicInfo(data, e) {
      // 选择的单位重复
      let num = 0;
      // 遍历表单
      this.unionTableData.map((e, i) => {
        // 如果表单中存在与单位相同的
        if (e.unionCorpId === data.id) {
          num++;
        }
      });
      // 如果选择的单位重复
      if (num > 0) {
        // 提示
        this.$message.error("选择的单位是联合体单位，请重新选择！");
        return false;
      }
      // 施工单位
      if (e == "construction") {
        // 如果选择的企业信息是勘察单位
        if (data.id == this.form.econUnit) {
          // 提示
          this.$message.error("选择的企业为勘察单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是设计单位
        else if (data.id == this.form.designUnit) {
          // 提示
          this.$message.error("选择的企业为设计单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是监理单位
        else if (data.id == this.form.superUnit) {
          // 提示
          this.$message.error("选择的企业为监理单位，请重新选择！");
          return false;
        }
        // 设置施工单位编号
        this.form.constructionUnit = data.id;
        // 设置施工单位名称
        this.form.constructionUnitName = data.corpName;
        // 清空项目负责人编号
        this.form.projectManager = null;
        // 清空项目负责人名称
        this.form.projectManagerName = null;
        // 清空项目负责人社会信用代码
        this.form.projectManagerIdCard = null;
      }
      // 勘察单位
      else if (e == "econ") {
        // 如果选择的企业信息是施工单位
        if (data.id == this.form.constructionUnit) {
          // 提示
          this.$message.error("选择的企业为施工单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是设计单位
        else if (data.id == this.form.designUnit) {
          // 提示
          this.$message.error("选择的企业为设计单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是监理单位
        else if (data.id == this.form.superUnit) {
          // 提示
          this.$message.error("选择的企业为监理单位，请重新选择！");
          return false;
        }
        // 设置勘察单位编号
        this.form.econUnit = data.id;
        // 设置勘察单位名称
        this.form.econUnitName = data.corpName;
        // 清空勘察单位项目负责人编号
        this.form.econProjectManager = null;
        // 清空勘察单位项目负责人名称
        this.form.econProjectManagerName = null;
        // 清空勘察单位项目负责人社会信用代码
        this.form.econProjectManagerIdCard = null;
        this.econProjectCostDisabled = false;
      }
      // 设计单位
      else if (e == "design") {
        // 如果选择的企业信息是施工单位
        if (data.id == this.form.constructionUnit) {
          // 提示
          this.$message.error("选择的企业为施工单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是勘察单位
        else if (data.id == this.form.econUnit) {
          // 提示
          this.$message.error("选择的企业为勘察单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是监理单位
        else if (data.id == this.form.superUnit) {
          // 提示
          this.$message.error("选择的企业为监理单位，请重新选择！");
          return false;
        }
        // 设置设计单位编号
        this.form.designUnit = data.id;
        // 设置设计单位名称
        this.form.designUnitName = data.corpName;
        // 清空设计单位项目负责人编号
        this.form.designProjectManager = null;
        // 清空设计单位项目负责人名称
        this.form.designProjectManagerName = null;
        // 清空设计单位项目负责人社会信用代码
        this.form.designProjectManagerIdCard = null;
        this.designProjectCostDisabled = false;
      }
      // 监理单位
      else if (e == "super") {
        // 如果选择的企业信息是施工单位
        if (data.id == this.form.constructionUnit) {
          // 提示
          this.$message.error("选择的企业为施工单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是勘察单位
        else if (data.id == this.form.econUnit) {
          // 提示
          this.$message.error("选择的企业为勘察单位，请重新选择！");
          return false;
        }
        // 如果选择的企业信息是设计单位
        else if (data.id == this.form.designUnit) {
          // 提示
          this.$message.error("选择的企业为设计单位，请重新选择！");
          return false;
        }
        // 设置监理单位编号
        this.form.superUnit = data.id;
        // 设置监理单位名称
        this.form.superUnitName = data.corpName;
        // 清空监理单位项目负责人编号
        this.form.superProjectManager = null;
        // 清空监理单位项目负责人名称
        this.form.superProjectManagerName = null;
        // 清空监理单位项目负责人社会信用代码
        this.form.superProjectManagerIdCard = null;
        this.superProjectCostDisabled = false;
      }
    },
    /**
     * 打开项目负责人弹窗
     */
    fun_OpenProjectManagerDialog(e) {
      // 单位编号
      let corpId = "";
      // 施工单位
      if (e == "construction") {
        // 如果施工单位名称为空
        if (!this.form.constructionUnitName) {
          // 提示
          this.$message.error("请先选择施工单位！");
          return false;
        }
        // 设置单位编号为施工单位
        corpId = this.form.constructionUnit;
      }
      // 勘察单位
      else if (e == "econ") {
        // 如果勘察单位名称为空
        if (!this.form.econUnitName) {
          // 提示
          this.$message.error("请先选择勘察单位！");
          return false;
        }
        // 设置单位编号为勘察单位
        corpId = this.form.econUnit;
      }
      // 设计单位
      else if (e == "design") {
        // 如果设计单位名称为空
        if (!this.form.designUnitName) {
          // 提示
          this.$message.error("请先选择设计单位！");
          return false;
        }
        // 设置单位编号为设计单位
        corpId = this.form.designUnit;
      }
      // 监理单位
      else if (e == "super") {
        // 如果监理单位名称为空
        if (!this.form.superUnitName) {
          // 提示
          this.$message.error("请先选择监理单位！");
          return false;
        }
        // 设置单位编号为监理单位
        corpId = this.form.superUnit;
      }
      // 打开弹窗
      this.$refs.regPersonBasicinfoChoose.dialogVisible = true;
      // 设置单位类型
      this.$refs.regPersonBasicinfoChoose.unitType = e;
      // 设置操作标志
      this.$refs.regPersonBasicinfoChoose.form.czbz = "subPrjManager";
      // 设置施工单位编号
      this.$refs.regPersonBasicinfoChoose.form.subUnitId = corpId;
      // 请求接口
      this.$refs.regPersonBasicinfoChoose.fun_GetOpen();
    },
    /**
     * 清空项目负责人
     */
    fun_CleanProjectManager(e) {
      // 施工单位
      if (e == "construction") {
        // 清空项目负责人编号
        this.form.projectManager = null;
        // 清空项目负责人名称
        this.form.projectManagerName = null;
        // 清空项目负责人社会信用代码
        this.form.projectManagerIdCard = null;
      }
      // 勘察单位
      else if (e == "econ") {
        // 清空勘察单位项目负责人编号
        this.form.econProjectManager = null;
        // 清空勘察单位项目负责人名称
        this.form.econProjectManagerName = null;
        // 清空勘察单位项目负责人社会信用代码
        this.form.econProjectManagerIdCard = null;
      }
      // 设计单位
      else if (e == "design") {
        // 清空设计单位项目负责人编号
        this.form.designProjectManager = null;
        // 清空设计单位项目负责人名称
        this.form.designProjectManagerName = null;
        // 清空设计单位项目负责人社会信用代码
        this.form.designProjectManagerIdCard = null;
      }
      // 监理单位
      else if (e == "super") {
        // 清空监理单位项目负责人编号
        this.form.superProjectManager = null;
        // 清空监理单位项目负责人名称
        this.form.superProjectManagerName = null;
        // 清空监理单位项目负责人社会信用代码
        this.form.superProjectManagerIdCard = null;
      }
    },
    /**
     * 设置项目负责人
     */
    fun_SetProjectManager(data, e) {
      // 施工单位
      if (e == "construction") {
        // 项目负责人编号
        this.form.projectManager = data.id;
        // 项目负责人名称
        this.form.projectManagerName = data.personName;
        // 项目负责人社会信用代码
        this.form.projectManagerIdCard = data.idCard;
      }
      // 勘察单位
      else if (e == "econ") {
        // 勘察单位项目负责人编号
        this.form.econProjectManager = data.id;
        // 勘察单位项目负责人名称
        this.form.econProjectManagerName = data.personName;
        // 勘察单位项目负责人社会信用代码
        this.form.econProjectManagerIdCard = data.idCard;
      }
      // 设计单位
      else if (e == "design") {
        // 设计单位项目负责人编号
        this.form.designProjectManager = data.id;
        // 设计单位项目负责人名称
        this.form.designProjectManagerName = data.personName;
        // 设计单位项目负责人社会信用代码
        this.form.designProjectManagerIdCard = data.idCard;
      }
      // 监理单位
      else if (e == "super") {
        // 监理单位项目负责人编号
        this.form.superProjectManager = data.id;
        // 监理单位项目负责人名称
        this.form.superProjectManagerName = data.personName;
        // 监理单位项目负责人社会信用代码
        this.form.superProjectManagerIdCard = data.idCard;
      }
    },
    /**
     * 打开联合体单位选择弹窗
     */
    fun_OpenUnionCorpDialog() {
      // 打开弹窗
      this.$refs.corpBasicinfoChoose.dialogVisible = true;
      // 设置联合体标志
      this.$refs.corpBasicinfoChoose.unionFlag = "1";
      // 请求接口
      this.$refs.corpBasicinfoChoose.fun_GetOpen();
    },
    /**
     * 设置联合体投标单位
     */
    fun_SetUnionBasicInfo(e) {
      // 联合体投标单位主键id赋值
      this.unionForm.unionCorpId = e.id;
      // 联合体投标单位名称赋值
      this.unionForm.unionCorpName = e.corpName;
    },
    /**
     * 联合体单位保存，清空
     */
    fun_OpenUnionCorp(e) {
      // 清空
      this.errRules.isUnion = "";
      // 如果是保存
      if (e == "add") {
        // 如果联合体单位编号为空
        if (!this.unionForm.unionCorpId) {
          // 错误提示
          this.$message.error("联合体单位未选择，请检查后再添加！");
          return false;
        }
        // 如果联合体单位编号为空
        if (!this.unionForm.unionUnitType) {
          // 错误提示
          this.$message.error("联合体单位类型未选择，请检查后再添加！");
          return false;
        }
        // 如果联合体单位与承包单位相同
        if (this.unionForm.unionCorpId == this.form.constructionUnit) {
          // 错误提示
          this.$message.error("联合体单位不能选择施工单位，请检查后再添加！");
          return false;
        }
        // 如果选择的企业信息是勘察单位
        if (this.unionForm.unionCorpId == this.form.econUnit) {
          // 提示
          this.$alert("选择的企业为勘察单位，请重新选择！", "warning");
          this.$message.error("联合体单位不能选择勘察单位，请检查后再添加！");
          return false;
        }
        // 如果选择的企业信息是设计单位
        if (this.unionForm.unionCorpId == this.form.designUnit) {
          // 提示
          this.$message.error("联合体单位不能选择设计单位，请检查后再添加！");
          return false;
        }
        // 如果选择的企业信息是监理单位
        if (this.unionForm.unionCorpId == this.form.superUnit) {
          // 提示
          this.$message.error("联合体单位不能选择监理单位，请检查后再添加！");
          return false;
        }
        // 错误数
        let count = 0;
        // 下标
        let unionRowNum = 0;
        // 遍历表单
        this.unionTableData.map((e, i) => {
          // 如果表单中存在与添加的企业相同的
          if (
            e.unionCorpId === this.unionForm.unionCorpId &&
            e.unionCorpId != this.unionFlag
          ) {
            count++;
          }
          // 如果表单与当前需要修改的主键相同
          if (e.unionCorpId == this.unionFlag) {
            // 设置下标
            unionRowNum = i;
          }
        });
        // 存在错误
        if (count > 0) {
          this.$message.error("联合体单位选择重复，请修改后再保存！");
          return;
        }
        // 设置表单
        let form = this.unionForm;
        // 如果操作标志为空
        if (this.unionFlag == "" || this.unionFlag == null) {
          // 添加表单
          this.unionTableData = [
            ...this.unionTableData,
            {
              ...form
            }
          ];
        }
        // 操作标志为修改
        else {
          // 将改对象直接从数组中替换
          this.unionTableData.splice(unionRowNum, 1, deepCopy(form));
        }
        // 清空操作标志
        this.unionFlag = "";
        // 联合体投标单位主键id清空
        this.unionForm.unionCorpId = "";
        // 联合体投标单位名称清空
        this.unionForm.unionCorpName = "";
        // 联合体单位类型清空
        this.unionForm.unionUnitType = "";
        // 联合体单位类型名称清空
        this.unionForm.unionUnitTypeName = "";
      }
      // 如果是清空
      else {
        // 联合体投标单位主键id清空
        this.unionForm.unionCorpId = "";
        // 联合体投标单位名称清空
        this.unionForm.unionCorpName = "";
        // 联合体单位类型清空
        this.unionForm.unionUnitType = "";
        // 联合体单位类型名称清空
        this.unionForm.unionUnitTypeName = "";
      }
    },
    /**
     * 联合体单位修改删除
     */
    fun_GetUnionBasicInfo(i, e) {
      // 如果是修改
      if (i == "update") {
        // 设置操作标志
        this.unionFlag = e.unionCorpId;
        // 联合体投标单位主键id赋值
        this.unionForm.unionCorpId = e.unionCorpId;
        // 联合体投标单位名称赋值
        this.unionForm.unionCorpName = e.unionCorpName;
        // 联合体单位类型赋值
        this.unionForm.unionUnitType = e.unionUnitType;
        // 联合体单位类型名称赋值
        this.unionForm.unionUnitTypeName = e.unionUnitTypeName;
      }
      // 如果是删除
      else {
        // 弹出询问confirm
        this.$confirm("确认删除该联合体信息吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 遍历表单
          this.unionTableData.map((j, i) => {
            // 判断需要删除的企业
            if (e.unionCorpId === j.unionCorpId) {
              // 删除勾选的数据
              this.unionTableData.splice(i, 1);
            }
          });
          // 联合体投标单位主键id清空
          this.unionForm.unionCorpId = "";
          // 联合体投标单位名称清空
          this.unionForm.unionCorpName = "";
          // 联合体单位类型清空
          this.unionForm.unionUnitType = "";
          // 联合体单位类型名称清空
          this.unionForm.unionUnitTypeName = "";
        });
      }
    },
    /**
     * 工程施工单位项目管理机构配备
     */
    fun_OpenOrganizationAllocationinfoDialog() {
      // 打开弹窗
      this.$refs.organizationAllocation.dialogVisible = true;
      // 操作标志
      let controllerFlg = this.controllerFlg;
      // 公示状态为提交
      if (this.form.publishState == "tj") {
        // 设置为详情
        controllerFlg = "detail";
      }
      // 设置直接发包备案主键
      this.$refs.organizationAllocation.contractRecordDirectlyId = this.form.id;
      // 设置项目名称
      this.$refs.organizationAllocation.prjName = this.form.prjName;
      // 设置操作标志
      this.$refs.organizationAllocation.controllerFlg = controllerFlg;
      // 请求接口
      this.$refs.organizationAllocation.fun_Open();
    },
    /**
     * 直接发包备案记录
     */
    fun_OpenRecordDirectlyLogsDialog() {
      // 打开弹窗
      this.$refs.recordDirectlyLogs.dialogVisible = true;
      // 设置直接发包备案主键
      this.$refs.recordDirectlyLogs.originalId = this.form.id;
      // 请求接口
      this.$refs.recordDirectlyLogs.fun_GetList();
    },
    /**
     * 修改发包人
     */
    fun_UpdateFbr() {
      // 弹出询问confirm
      this.$confirm(
        "发包人信息或施工单位修改后需重新公示72小时，确定修改发包人信息或施工单位吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        // 设置修改标志（修改发包人数据）
        this.form.updateFlag = "1";
        // 显示标志显示
        this.showFlag = true;
        // 房屋建筑工程建筑面积取消置灰
        this.constructionAreaDisabled = false;
        // 遍历流程
        this.stepsList.map(e => {
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 如果是
              if (
                form.value == "prjName" || // 工程名称
                form.value == "regulators" || // 备案部门
                form.value == "tenderClassNum" || // 备案项目类别
                form.value == "tenderContentNum" || // 备案项目内容
                form.value == "buildingLandObtained" || // 建设用地取得方式
                form.value == "linkMan" || // 建设单位法人授权委托人
                form.value == "linkTel" || // 授权委托人电话
                form.value == "recordUnitName" || // 项目批准机构
                form.value == "projectSite" || // 工程地点
                form.value == "approvalName" || // 批文名称
                form.value == "noteNumber" || // 立项批准文号
                form.value == "fundsSources" || // 资金来源
                form.value == "fundsCharacter" || // 资金性质
                form.value == "situation" || // 资金来源落实情况
                form.value == "structuralHierarchy" || // 结构层次
                form.value == "municipalProjectScale" || // 市政工程规模
                form.value == "otherProjectScale" // 其它工程规模
              ) {
                // 取消置灰
                form.disabled = false;
              }
            });
          });
        });
      });
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor(e) {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 设置文件类型
      this.$refs.tenderPictureinfor.type = e;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    }
  }
};
